import type { App } from 'vue';
import api from '../api/index.ts';

const VueApi = {
    install(app: App) {
        app.config.globalProperties.$api = api;
        app.provide('$api', api);
    },
};

export default VueApi;
